import { Translations } from '../translations.type';

const zh: Translations = {
  lang: '中文',
  app_title: 'Poker BTI',
  app_subtitle: '德州扑克人格类型测试',
  app_description:
    '十六种德州扑克人格，十二道快问快答，看看牌桌上的你到底是哪一型。',
  home_cta_start: '开始测试',
  home_footnote: '约 2 分钟 · 12 道题',

  wizard_progress: (current: number, total: number) =>
    `第 ${current} 题 / 共 ${total} 题`,
  wizard_prev: '上一题',
  wizard_next: '下一题',
  wizard_finish: '查看我的类型',
  wizard_pick_hint: '选一个最像你的答案',

  loading_messages: [
    '正在洗牌……',
    '正在数你的 outs……',
    '正在跑 solver……',
    '正在读牌桌……',
    '正在发你的人格牌……',
  ],

  result_title: '你是',
  result_subtitle: '你的扑克人格',
  result_retake: '重新测试',
  result_share: '分享',
  result_share_text: (code: string, name: string) =>
    `我是 ${code} —— ${name}。你的扑克人格是？`,
  result_axes_heading: '你的四个维度',

  share_button: '分享',
  share_title: '分享 Poker BTI',
  share_link_label: '链接',
  share_copy: '复制链接',
  share_copied: '已复制！',
  share_close: '关闭',
  share_scan_hint: '或扫描二维码',
  share_via: '分享到',
  share_native: '分享…',
  share_default_text: 'Poker BTI —— 12 道题，测出你的德州扑克人格。',
  share_on: (network: string) => `分享到 ${network}`,

  footer_author: '作者',
  footer_source: '源码',

  axis_NM: '石佛 — 疯子',
  axis_SC: '主攻 — 跟注',
  axis_GV: '数学 — 直觉',
  axis_IT: '淡定 — 上头',

  axis_NM_tagline: '你真正下场打的牌，范围到底有多宽？',
  axis_SC_tagline: '筹码进池的时候，是你在推，还是你在跟？',
  axis_GV_tagline: '是用频率和数学决策，还是看人下菜碟、凭感觉拍板？',
  axis_IT_tagline: '被一记暴击之后，你会冷静下来，还是直接沸腾？',

  pole_N: '石佛',
  pole_M: '疯子',
  pole_S: '主攻',
  pole_C: '跟注',
  pole_G: 'GTO党',
  pole_V: '直觉党',
  pole_I: '淡定',
  pole_T: '上头',

  pole_N_description:
    '弃，弃，弃。UTG 的 AJo？弃。OOP 的同花连子？算了。等你真把筹码推进去的时候，全桌已经默认你有牌——而你也确实有。纪律不性感，但凌晨一点把家底打没更不性感。',
  pole_M_description:
    '任何两张都能赢，而你打算亲自证明这一点。开池宽，防守宽，3-bet 轻，绝不让一巡牌白白过去。有时候是天才操作，有时候是史诗级翻车，反正一定不无聊。',
  pole_S_description:
    '看牌是懦夫的选择。你下注做价值，下注施加弃牌压力，下注因为前面都过牌了总得有人动手。主动权是你的爱语，底池在你身边永远在长大。',
  pole_C_description:
    '能跟就别加。能小跟就别大跟。让对手自己挂自己，让他们的范围保持宽阔，相信好牌只要你不挡道就会自己走完。底池控制不是一种打法，是一种生活方式。',
  pole_G_description:
    '范围、频率、MDF、blocker、EV。每个 spot 都是一棵 solver 树，每条河牌都是一组 value-to-bluff。你不关心对手今晚"拿了什么"，你关心他"应该拿什么"，然后按那个频率下注。方差只是采样噪音。',
  pole_V_description:
    '他过牌之前叹了口气；她下注之前瞄了一眼筹码；这块面感觉像个陷阱。你读人，不读图。你相信牌桌告诉你的东西比任何 solver 都多。数据是后备，不是老板。',
  pole_I_description:
    '被暴击？原计划。坏 beat？原计划。河牌两张外？原计划。方差对你而言只是天气——偶尔很烦，从不针对。打到通宵脸都没动一下。安静的机器，平稳运转。',
  pole_T_description:
    '牌一歪，你也跟着歪。开得更宽，下得更大，hero call 得更快，上一手怎么都放不下。有时候火气是燃料，下一局你直接屠桌；有时候火气就是火灾。无论如何，动静都很大。',

  questions: {
    q1: {
      question: '看了一眼自己的两张底牌。还行吧，不算特别好。你:',
      options: [
        '弃了。一般的牌干嘛要花钱跟？',
        '跟。翻牌只要出张好牌，立刻封神。',
      ],
    },
    q2: {
      question: '连续十手牌，你每一手都弃了。你:',
      options: [
        '继续等。耐心就是全部。',
        '别等了，下场玩。你是来打牌的，不是来观摩的。',
      ],
    },
    q3: {
      question: '朋友问你怎么一直弃牌。你说:',
      options: [
        '"相信我，那些牌真的不能打。"',
        '没说话。因为你才没弃那么多牌。（其实弃了。）',
      ],
    },
    q4: {
      question: '翻牌你真的打中了好东西。轮到你下注，你:',
      options: [
        '大注。让他们花钱看你的牌。',
        '小注或者过牌。别一下把人吓跑。',
      ],
    },
    q5: {
      question: '前面一圈都过牌过到你。底池在那儿没人动。你:',
      options: [
        '下注。别客气了，拿下。',
        '也过牌。先看看他们下家怎么办。',
      ],
    },
    q6: {
      question: '对手下注，你的牌"也许能赢，也许不能"。你:',
      options: [
        '加注。让他们来做这个难题。',
        '只跟。再看一张牌再决定。',
      ],
    },
    q7: {
      question: '大底池一个大决定。你靠什么决定:',
      options: [
        '心算。赔率、outs、数字。',
        '盯着对面看。他在出汗吗？他在出汗。',
      ],
    },
    q8: {
      question: '你在 YouTube/B站看扑克视频，主要爱看:',
      options: [
        '策略讲解、图表、"正确打法是这样"。',
        '神之抓注、桌上互怼、"他到底是怎么知道的？"',
      ],
    },
    q9: {
      question: '对手突然下了个 size 很奇怪的注。你第一反应:',
      options: [
        '"嗯……这个 size 什么意思？合理范围里有哪些牌？"',
        '"有问题。要么纯诈唬，要么坚果。"',
      ],
    },
    q10: {
      question: '河牌发出最烂的那张，你刚输了一个大池子。你:',
      options: [
        '耸耸肩，把剩下的筹码码好，下一手。',
        '叹一口气，可能还骂一句。接下来一小时都在想这件事。',
      ],
    },
    q11: {
      question: '你已经输了一整晚。下一手你会:',
      options: [
        '还是按原来的方式打。方差就是方差。',
        '打得更松，下得更大。筹码现在就得回来。',
      ],
    },
    q12: {
      question: '有个对手一整晚都在赢你的钱，还乐在其中。你:',
      options: [
        '不理他，打自己的。他的报应会来的。',
        '这变成私人恩怨了。今晚不赢他一手不行。',
      ],
    },
  },

  types: {
    NSGI: {
      name: '赛博杀手',
      tagline: '紧凶 + solver 加持 + 面无表情，最纯正的现代屠夫。',
      description:
        '现代职业的标准模板。你没有"手牌"，只有"范围"；你没有"感觉"，只有 EV。每条线都研究过，每个 sizing 都有意图，被暴击的时候表情也不会动一下。对手读不懂你，因为你身上没什么好读的。',
    },
    NSGT: {
      name: '崩坏的量化师',
      tagline: '前三个小时打 GTO，KK 一被 AA 暴击就直接喷火。',
      description:
        '脑子和赛博杀手一样，但多了一颗心脏——而那颗心脏就是漏洞。完美打三小时，一次暴击就让你开始 4-bet all-in 套餐。下一场又会变回理性，下一次暴击大概也会再来。',
    },
    NSVI: {
      name: '冷面狙击手',
      tagline: '一巡观察，一个读牌，一发入魂。',
      description:
        '老派线下职业玩家的气场。范围紧、打法凶、面如止水——但驱动你的是人，不是 solver。你看三巡，挑出最软的对手，设好陷阱，开一枪，然后回归隐形。',
    },
    NSVT: {
      name: '英雄抓注',
      tagline: '"我就是知道。"（旁白：他并不知道。）',
      description:
        '耐心、强硬、靠读牌——而且对每一次读牌全情投入。抓中的时候是扑克里最爽的瞬间；抓不中，整晚就变成"下一次一定抓中"的连续尝试。你讲过的那个 2023 年的 hero call 故事，确实是个好故事。',
    },
    NCGI: {
      name: '人形计算器',
      tagline: '正确弃牌，正确输钱，正确报税。',
      description:
        '紧、被动、彻底正确、彻底淡定。你打的池子小，吃的 edge 也小，从不诈唬，也从来不会被人从坚果上吓跑。慢慢往上漂，或者慢慢往下漂，速度刚好等于数学预测的那个值。有人说你是 nit，你说这叫可持续。',
    },
    NCGT: {
      name: '忧郁解算师',
      tagline: '弃牌正确，心情糟糕。',
      description:
        '你知道这是正确的弃牌。你做出了正确的弃牌。然后用接下来的四十五分钟抱怨这次正确的弃牌，顺便点一个芝士汉堡，再刷新一下你的追踪软件。决策很稳，心情中等，椅子还是那把椅子。',
    },
    NCVI: {
      name: '老和尚',
      tagline: '据说从 2019 年起就没眨过眼。',
      description:
        '紧、被动、凭直觉、彻底佛系。弃，弃，弃，弃，安静地用坚果跟一发，再弃。牌桌忘记了你的存在，抽水却没忘。内心平静，盈利轻薄。',
    },
    NCVT: {
      name: '怨念星人',
      tagline: '吐槽贴已经打好草稿了。',
      description:
        '紧被动的"感觉党"，但运气死活不站你这边。翻前被暴击，河牌被反超，连续十八手发到 7-2。也许就是运气差，也许吧。这套发牌没人能取名，但今晚你的名字一定会成为大家最不想听到的名字。',
    },
    MSGI: {
      name: '现代屠夫',
      tagline: '现代 LAG，HUD 开着，脑子在线，灵魂未塌。',
      description:
        '终局形态。范围宽，打法凶，理论扎实，方差面前面不改色。你施加的压力对手"理论上"知道怎么防，但"实际上"扛不住。多半有教练，肯定有 HUD，可能还有女朋友。',
    },
    MSGT: {
      name: '浪到飞起',
      tagline: '+12 个买入，-15 个买入，没有遗憾。',
      description:
        '范围宽、打法凶、有数学——直到热度上来。三小时赢十二个买入，然后用十五个买入去赢第十三个。明天你会复盘这些手牌，精准指出哪里出了问题，然后下周再来一次。净盈利：勉强。氛围感：拉满。',
    },
    MSVI: {
      name: '持枪牛仔',
      tagline: '河牌还没翻你就开始盯着它了。',
      description:
        '线下 LAG 的气场。范围宽，下注大，眼神更长。你出于原则 3-bet 那些 reg，盯诈唬时眼神像是已经提前看过河牌。命中的时候桌子瞬间安静，没中就再补一买入继续盯。',
    },
    MSVT: {
      name: '疯狂大哥',
      tagline: '盲推。从不道歉。',
      description:
        '纯粹的混乱。盲推。每条街都拿空气打满池。最大买入买进来，输光最大买入再补一次，柜台让买你还买。我们不懂你，但你撑起了这局牌；属于你的那个晚上，筹码榜上没人能比。',
    },
    MCGI: {
      name: '学院派站台',
      tagline: '什么都跟，跟得有理有据，结果还是输。',
      description:
        '你跟。你又跟。你用频率图解释，每一次跟注"技术上"都是合理的——它们也确实是。但表格还是显示亏损。打牌打得最讲道理的输家，往往是最折磨人的对手。',
    },
    MCGT: {
      name: '反向脑回路',
      tagline: '"我有 blocker。"——blocker 对面的牌。',
      description:
        '"我有 blocker。" 对坚果同花。手里却是 7-2 杂色。你把宽范围、被动线、一知半解的 solver 词汇和不稳定的情绪混在一起，调成一种谁都解释不清（包括你自己）的打法。它有时候真的能赢。声音很大。',
    },
    MCVI: {
      name: '佛系鱼鱼',
      tagline: '笑着跟注，笑着付钱，顺手给荷官小费。',
      description:
        '你是来玩的，不是来赢的。范围宽、打法被动、不算数学、不发脾气、没有问题。你抽到对手是笑，被对手抽到也是笑，无论如何都给荷官小费。牌桌上最招人喜欢的那位——也是 reg 们坚持回来的原因。',
    },
    MCVT: {
      name: '赌瘾少年',
      tagline: '来赌。正在赌。还要赌。',
      description:
        '动作，更多动作，全是动作。任何下注你都跟，任何听牌你都追，任何感觉你都信，一手不顺立刻上头——然后立刻打下一手。资金管理只是个传说。下一手就是一切。',
    },
  },
};

export default zh;
